import React from 'react';

import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ModuleHeader, ModuleHeaderSize } from '@/components/ModuleHeader';
import { ModuleProductsSkeleton } from '@/components/ModuleProductsSkeleton';

export function BasedOnRecentViewsPlaceholder() {
  const t = useTranslations('product');
  return (
    <section>
      <ModuleHeader
        title={t('BasedOnYourRecentViews')}
        size={ModuleHeaderSize.Large}
      />
      <ModuleProductsSkeleton
        itemsPerRow={6}
        productsCount={6}
        className={styles.scrollableItemRow}
        attributesClassName={styles.attributesSkeleton}
        minItemWidth={144}
      />
    </section>
  );
}
